module.exports = __webpack_public_path__ + "static/media/candidatesupport1.73b95d46.png";